"use client";

/**
 * Backwards-compatible wrapper.
 * Prefer `useMediaAssetGet` from `@/features/media/hooks`.
 */

import { EntryType, MediaGroup } from "@/openapi/generated/models";
import { useMediaAssetGet } from "@/features/media/hooks";

interface UseTenantLogoGetProps {
  tenantId: number;
}

export const useTenantLogoGet = (
  { tenantId }: UseTenantLogoGetProps,
  options?: { enabled?: boolean },
) => {
  const result = useMediaAssetGet(
    {
      tenantId,
      ownerType: EntryType.Tenant,
      ownerId: tenantId,
      mediaGroup: MediaGroup.Logo,
    },
    options,
  );

  return {
    data: result.data
      ? { logoUrl: result.url, mediaId: result.mediaId }
      : undefined,
    logoUrl: result.url,
    mediaId: result.mediaId,
    isError: result.isError,
    isLoading: result.isLoading,
    isSuccess: result.isSuccess,
    isPending: result.isPending,
  };
};

